import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { DialogContentBase } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-notification-group-popup',
  templateUrl: './notification-group-popup.component.html',
  styleUrls: ['./notification-group-popup.component.scss']
})
export class NotificationGroupPopupComponent extends DialogContentBase {
  public notifiactionGroupList: Array<String> = [];
  public windowOpened = false;
  public showClearButton: boolean = false;
  public searchText: string = '';
  public filteredList: Array<String> = [];

  @ViewChild('popupModal') public modal?: ElementRef;
  @Input() public dialogOpened: boolean = false;
  @Input() public message: string = '';
  @Input() public header: string = '';
  @Input() public actionYesLabel: string = '';
  @Input() public actionNoLabel: string = '';
  @Input() public isInfo = false;
  @Output() public submitted = new EventEmitter();
  @Output() public cancelled = new EventEmitter();

  public close() {
    this.dialog.close();
  }

  public onClearSearchTextClicked() {
    this.filterList();
  }

  public onChangeSearchText() {
    this._updateSearchTextClearButtonVisibility();
  }

  public onSeachClearButtonClick() {
    this.searchText = '';
    this.filterList();
    this._updateSearchTextClearButtonVisibility();
  }

  public onFilterTextEnterKeyPress() {
    this.filterList();
  }

  public onSearchButtonClick() {
    this.filterList();
  }

  private filterList() {
    if (this.searchText && this.searchText !== '') {
      this.filteredList = this.notifiactionGroupList.filter(f => f.toLowerCase().includes(this.searchText.toLowerCase()));
    }
    else {
      this.filteredList = this.notifiactionGroupList;
    }
  }

  private _updateSearchTextClearButtonVisibility() {

    if (this.searchText && this.searchText !== '') {
      this.showClearButton = true;
    } else {
      this.showClearButton = false;
    }
  }
}
